import { render } from "./FileIndicator.vue?vue&type=template&id=8a8f837e&scoped=true"
import script from "./FileIndicator.vue?vue&type=script&lang=js"
export * from "./FileIndicator.vue?vue&type=script&lang=js"

import "./FileIndicator.vue?vue&type=style&index=0&id=8a8f837e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8f837e"]])

export default __exports__